import SSOClient from '../services/auth'
import StockClient from './StockClient'

export const ssoClient = new SSOClient()
export const stockClient = new StockClient()
